import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { ChartInterval } from "@/adapters/api";

interface DashboardCurveIntervalState {
	interval: ChartInterval;
	setInterval: (interval: ChartInterval) => void;
}

export const useDashboardCurveInterval = create<DashboardCurveIntervalState>()(
	persist(
		(set) => ({
			interval: "monthly",
			setInterval: (interval) => set({ interval }),
		}),
		{
			name: "otd-dashboard-curve-interval",
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);
